import { XMarkThin } from "@/icons";
import { ComponentProps, FC } from "react";

export const CloseButton: FC<ComponentProps<"button">> = ({ ...props }) => {
  return (
    <button
      aria-label="Close"
      className="bg-swdc-white focus:outline-swdc-blue-400 focus-visible:outline-swdc-blue-400 active:outline-swdc-blue-400 lg:hover:bg-swdc-gray-100 absolute top-2 right-2 z-10 rounded-full p-1.5 transition-colors focus:outline focus-visible:outline active:outline lg:top-5 lg:right-5 lg:p-3"
      {...props}
    >
      <XMarkThin aria-hidden className="size-6" />
    </button>
  );
};
